<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <el-row :gutter="20" id="knowus">
        <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Una historia Chévere</h1></el-col>
        <br>
        <el-col :xs="24" :md="12">
            <p class="chevere-text-j">ChévereTech es una empresa que brinda servicios a medida, según el requerimiento, podemos mejorar los procesos y facilitar los trabajos dentro de la organización, nos caracterizamos por  nuestro soporte técnico y atención, así como actitud ante las adversidades que se puedan presentar, los problemas de nuestros clientes también son nuestros. Además, brindamos soluciones relacionadas con la legislación que exige tener soluciones en TI, tal como lo es la facturación electrónica, y productos propios para problemáticas cotidianas de nuestros clientes.</p>
            <p class="chevere-text-j">Somos un grupo de profesionales que tiene como objetivo solucionar las  problemáticas que nuestros clientes puedan presentar; trabajando con rapidez cumpliendo los plazos establecidos en el proyecto, involucrándonos en cada etapa del proyecto con la mejor de las actitudes, buscando siempre la satisfacción y resolución de los problemas planteados.</p>
        </el-col>
        <el-col class="hidden-md-and-up" :xs="24"><img class="isotipo" src="@/../public/assets/images/identidad/1.png" alt="ChevereTech" title="ChevereTech"></el-col>

        <el-col class="hidden-sm-and-down" :md="12"><img class="isotipo" src="@/../public/assets/images/identidad/isotipo.png" alt="ChevereTech" title="ChevereTech"></el-col>
    </el-row>
</template>

<script>
export default {
    name: "Mision",
}
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/sections/Nosotros.vue